"use client";

import { useEffect } from "react";
import "./globals.css";

// Same purpose as error.tsx, but for errors thrown by the ROOT layout itself
// (Providers, ThemeProvider, etc.) — Next.js requires a separate file for
// that case since error.tsx can't catch failures in the layout that renders
// it. This one has to render its own <html>/<body> since it fully replaces
// the root layout when it fires.
export default function RootErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[root error boundary]", error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: "var(--bg-base)" }}>
          <div className="w-full max-w-md text-center space-y-4">
            <h1 className="text-lg font-bold" style={{ color: "var(--text-1)" }}>Bunker Box failed to load</h1>
            <p className="text-sm" style={{ color: "var(--text-3)" }}>
              Something went wrong before the app could start. Try reloading — if it keeps
              happening, let staff know.
            </p>
            {error.digest && (
              <p className="text-xs font-mono" style={{ color: "var(--text-3)" }}>
                Reference: {error.digest}
              </p>
            )}
            <button
              onClick={reset}
              className="px-4 py-2 rounded-lg text-sm font-bold transition-colors"
              style={{ backgroundColor: "var(--amber)", color: "var(--primary-foreground)" }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
